import React from "react";
import "./style.less";

function AreaLabel({ name, type, area, selected, onClick }) {
  const selectedClass = selected ? "selected" : "";
  let displayArea = Math.round(area / 1000000);
  displayArea =
    displayArea === 0 ? Math.round(area) + " sq. m" : displayArea + " sq. Km";
  return (
    <div className={`${selectedClass} ${type} AreaLabelContainer`}>
      <div onClick={onClick} className={`inverted AreaLabel`}>
        <div className="name">{`${name}`}</div>
        <div className="area">{`${displayArea}`}</div>
      </div>
    </div>
  );
}
export default AreaLabel;
